import Button from "components/button";
import { useUTMParams } from "components/utms/useUTMParams";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import textServices from "services/text-services";

export default function Xeerpa() {
  const utmParams = useUTMParams();

  const search = useMemo(() => {
    const searchParams = new URLSearchParams({ 'tointernal': 'true' });

    for (const key in utmParams) {
      if (utmParams[key] && !searchParams.has(key)) {
        searchParams.set(key, utmParams[key]);
      }
    }

    return searchParams?.toString()
  }, [utmParams])


  return (
    <Link to={{ pathname: '/login-manager', search }} className="w-full space-y-3">
      <p className="text big text-center">{textServices.findByText('start/xeerpa/title', { es: 'Ingresa a tu dosequis id o crea tu cuenta para obtenerlo.', en: 'Enter your dosequis id or create your account to get it.' })}</p>
      <Button>
        {textServices.findByText('start/xeerpa/button', { es: '¡VAMOS!', en: 'GO!' })}
      </Button>
    </Link>
  )
}